export function getWindow<Win = Window>() {
  return window as unknown as Win;
}
